import React from 'react';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

/**
 * What a batch generate actually did. Skip reasons are fixed codes from
 * gl-api (below_threshold, corporate_exempt, already_exists, ...), never free
 * text, so they are translated here rather than displayed verbatim.
 */

interface CreatedForm {
  id: number;
  recipient_vendor_code?: string | null;
  recipient_legal_name: string;
  form_type: string;
  total_reportable_amount: string;
}

interface SkippedVendor {
  vendor_id: number;
  vendor_code: string;
  display_name: string;
  form_type?: string | null;
  reason: string;
}

interface Props {
  show: boolean;
  taxYear: number | null;
  created: CreatedForm[];
  skipped: SkippedVendor[];
  onClose: () => void;
}

const GenerateResultsModal: React.FC<Props> = ({ show, taxYear, created, skipped, onClose }) => {
  const { t } = useTranslation('Tax1099Forms');

  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{t('results.title', { year: taxYear })}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-success py-2">
          {t('results.created_count', { count: created.length })}
        </div>
        {created.length > 0 && (
          <ul className="list-unstyled mb-4">
            {created.map((form) => (
              <li key={form.id} className="mb-1">
                <code>{form.recipient_vendor_code}</code>{' '}
                {form.recipient_legal_name} — {form.form_type} —{' '}
                {Number(form.total_reportable_amount).toFixed(2)}
              </li>
            ))}
          </ul>
        )}

        {skipped.length > 0 && (
          <>
            <div className="alert alert-warning py-2">
              {t('results.skipped_count', { count: skipped.length })}
            </div>
            <ul className="list-unstyled mb-0">
              {skipped.map((skip, index) => (
                <li key={`${skip.vendor_id}-${skip.form_type ?? index}`} className="mb-1">
                  <code>{skip.vendor_code}</code> {skip.display_name}{' '}
                  <Badge bg="secondary">{t(`results.reasons.${skip.reason}`)}</Badge>
                </li>
              ))}
            </ul>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onClose}>{t('results.close')}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default GenerateResultsModal;
